import { useState, useRef, useEffect } from 'react';
import { Flex, Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import { DARK } from '../../../utilities/constants';
import Icon from '@ant-design/icons';
import { ReactComponent as SelectDropdownBlackSvg } from '../../../assets/icons/select-dropdown-black.svg';
import { ReactComponent as SelectDropdownSvg } from '../../../assets/icons/select-dropdown.svg';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const { Text } = Typography;

const defaultSelectOptions = [
  { label: 'Device Onboarding', value: 'onboarding-checklist' },
  { label: 'New Installation', value: 'install-a-new-device' },
  { label: 'Device Replacement', value: 'replace-old-device ' },
  { label: 'Device Uninstallation', value: 'uninstall-device' },
  { label: 'Company De-Registration', value: 'de-registration-of-customer' },
];

const DeviceActionDropdown = ({ selectOptions = defaultSelectOptions }) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const dropdownRef = useRef(null);
  const { theme } = useTheme();

  useEffect(() => {
    if (!isExpanded) return;

    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isExpanded]);

  return (
    <div
      style={{ position: 'relative', width: 'fit-content' }}
      ref={dropdownRef}
    >
      <Flex
        style={{
          backgroundColor: isExpanded
            ? 'var(--button-primary-selected-color, #9dc9ff)'
            : 'var(--button-default-bg-color, #0096e8)',
          padding: '12px 52px',
          cursor: 'pointer',
        }}
        justify="center"
        align="center"
        onClick={() => setIsExpanded(prev => !prev)}
        gap={8}
      >
        <Icon
          component={
            theme === DARK ? SelectDropdownBlackSvg : SelectDropdownSvg
          }
          rotate={isExpanded ? 0 : -90}
        />
        <Text style={{ color: 'var(--selected-text-color, #000000)' }}>
          Action Form
        </Text>
      </Flex>

      {isExpanded && (
        <div className="device-action-dropdown-div">
          {selectOptions.map((item, index) => (
            <Flex
              key={index}
              className="device-action-dropdown-item"
              onClick={() => {
                navigate(item?.value);
                setIsExpanded(false);
              }}
            >
              {item.label}
            </Flex>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeviceActionDropdown;

DeviceActionDropdown.propTypes = {
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ),
};
